/** Chart geometry/data-shaping helpers shared by web's and mobile's Logbook
 * trend charts — their rendering can't be shared (DOM/canvas vs Skia), but
 * these take/return plain numbers and strings. */
const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
/** `"2026-10-01"` -> `"1 Oct"`. Parses components directly to avoid
 * timezone-shifted `Date` parsing. */
export function logbookChartDayLabel(day) {
    const [, m, d] = day.split("-").map(Number);
    return `${d} ${MONTHS[(m ?? 1) - 1]}`;
}
/** Evenly spaced indices to label on a chart's x-axis, always including both ends. */
export function logbookChartTickIndices(length, maxTicks) {
    if (length <= 1)
        return [0];
    const count = Math.min(maxTicks, length);
    const seen = new Set();
    for (let i = 0; i < count; i++) {
        seen.add(Math.round((i * (length - 1)) / (count - 1)));
    }
    return Array.from(seen).sort((a, b) => a - b);
}
/** Nulls a line series' leading zero/null stretch, so it never drags a flat
 * tail before any real data exists. Bars still show the raw value. */
export function logbookChartGapLeadingZeros(values) {
    const firstReal = values.findIndex((v) => v !== null && v !== 0);
    if (firstReal <= 0)
        return [...values];
    return values.map((v, i) => (i < firstReal ? null : v));
}
/** Min-max normalizes to 0-100, for overlaying metrics with incompatible
 * units on one axis. A flat series normalizes to 50, not a division by zero. */
export function logbookChartNormalize(values) {
    const real = values.filter((v) => v !== null);
    if (real.length === 0)
        return values.map(() => null);
    const min = Math.min(...real);
    const max = Math.max(...real);
    if (max === min)
        return values.map((v) => (v === null ? null : 50));
    return values.map((v) => (v === null ? null : ((v - min) / (max - min)) * 100));
}
//# sourceMappingURL=logbook-chart-math.js.map